import styled from 'styled-components';
import { Box, Button, Icon } from '@wistia/ui';

export const TabWrapper = styled(Box).attrs({ direction: 'column', gap: 'space-05' })`
  width: 100%;
`;

export const SelectWrapper = styled(Box).attrs({ direction: 'column', gap: 'space-02' })`
  width: 100%;
`;

export const InlineSelectWrapper = styled(Box).attrs({ direction: 'row', gap: 'space-02' })`
  width: 100%;
`;

export const CheckboxWrapper = styled.div<{ margin?: string }>`
  background-color: ${({ theme }) => theme.color.grey100};
  border: 1px solid ${({ theme }) => theme.color.grey200};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin: ${({ margin }) => margin ?? 0};
  padding: 1rem;
  width: 100%;
`;

export const DownloadButton = styled(Button).attrs({
  size: 'lg',
  leftIcon: (
    <Icon
      type="download"
      style={{ marginLeft: '0.25rem' }}
    />
  ),
})`
  margin-left: auto;
`;
